/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_BadgeInputs */



/**
* | output |
* | --- |
* | "WAV Only" |
*
* @param {Audio_Description_Export_Bwf_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_badge = /** @type {((inputs?: Audio_Description_Export_Bwf_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("WAV uniquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur WAV")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo WAV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Только WAV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sólo WAV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仅限 WAV")
	if (locale === "ja") return /** @type {LocalizedString} */ ("WAVのみ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल WAV फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Somente WAV")
	return /** @type {LocalizedString} */ ("WAV Only")
});